export default {
  title: 'Fontes',
  description: 'Gerencie as fontes para uso nos sites.',
  labels:{
    new: 'Nova Fonte',
  },
  fields:{
    label: 'Nome da Fonte',
    value: 'Valor',
    family: 'Família de fontes',
    import: 'URL de importação',
  }
};
